export const CHOOSE_TAB = '@@myEnergy/choose_tab'

export const RESET_MY_ENERGY = '@@myEnergy/reset'
